export enum Page {
  product = 0,
  details = 1,
  checkout = 2,
  payment = 3,
}
